export default __webpack_public_path__ + "static/media/deploymentManager.efe8198b.svg";